var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestorFlow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 22.5001C21.3808 22.5001 22.5001 21.3808 22.5001 20.0001C22.5001 18.6194 21.3808 17.5001 20.0001 17.5001C18.6194 17.5001 17.5001 18.6194 17.5001 20.0001C17.5001 21.3808 18.6194 22.5001 20.0001 22.5001ZM25.6279 15.002H14.3779C14.0328 15.002 13.7529 15.2818 13.7529 15.627V24.3769C13.7529 24.7221 14.0328 25.0019 14.3779 25.0019H25.6279C25.9731 25.0019 26.2529 24.7221 26.2529 24.3769V15.627C26.2529 15.2818 25.9731 15.002 25.6279 15.002ZM15.0029 22.2791V17.7212C15.7065 17.5107 16.2614 16.9557 16.4715 16.252H23.5288C23.7394 16.9576 24.2966 17.5137 25.0029 17.7229V22.2774C24.2954 22.4869 23.7375 23.0446 23.5276 23.7519H16.4726C16.2633 23.0465 15.7078 22.4899 15.0029 22.2791Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestorFlow2);
export default __webpack_public_path__ + "static/media/investor_flow2.990c97452378b83e44aa532c2004366b.svg";
export { ForwardRef as ReactComponent };